import React, { useState, useEffect } from "react";
import "./LogoSlideshow.css";

const LogoSlideshow = () => {
  const [currentLogoIndex, setCurrentLogoIndex] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  const logos = [
    { name: "1", img: require("../../assets/Mileway.jpg"), link: "https://mileway.com/" },
    { name: "2", img: require("../../assets/BSstone.jpg"), link: "https://www.blackstone.com/" },
    { name: "3", img: require("../../assets/newsec111.jpg"), link: "https://www.newsec.se/" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setTransitioning(true);
      setTimeout(() => {
        setTransitioning(false);
        setCurrentLogoIndex((prevIndex) => (prevIndex + 1) % logos.length);
      }, 2000); // Time in center
    }, 3000); // Total time for one cycle

    return () => clearInterval(interval);
  }, [logos.length]);

  return (
    <div className="logo-slideshows">
      <h1 className="slideshow-container">Våra Nöjda Kunder</h1>
      <div className="logo-slideshow">
        {logos.map((logo, index) => (
          <a key={index} href={logo.link} target="_blank" rel="noopener noreferrer">
            <div
              className={`logo ${currentLogoIndex === index ? "active" : ""}`}
              style={{ backgroundImage: `url(${logo.img})` }}
            ></div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default LogoSlideshow;
